module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('country-flag', {
    attrs: {
      "country": _vm.flag,
      "size": "small"
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, [_c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('es')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "es",
      "size": "small"
    }
  }), _vm._v(" Español\n        ")], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('us')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "us",
      "size": "small"
    }
  }), _vm._v(" English\n        ")], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('de')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "de",
      "size": "small"
    }
  }), _vm._v(" Deutsche\n        ")], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('br')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "br",
      "size": "small"
    }
  }), _vm._v(" Português\n        ")], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cbcd03c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/LanguagesMenu.vue
// module id = 331
// module chunks = 1